export default "__VITE_ASSET__LWQNOsBV__"